import { Spin, Text } from '@gravity-ui/uikit';
import React from 'react';
import './styles/index.css';

export function AuthLoading() {
    return (
        <div className="auth-loading-container">
            <div className="auth-loading-content">
                <Spin size={'xl'} />
                <div>
                    <Text>Авторизация яндексоида</Text>
                </div>
            </div>
        </div>
    );
}
